import { GET_CUSTOMER_PORTAL_LINK } from 'modules/v2/store/constants';

export const getCustomerPortalLink = (redirectLink) => ({
  type: GET_CUSTOMER_PORTAL_LINK,
  payload: {
    redirectLink,
  },
});
